

// Popup message Fucntion

function load_new_popup_order_message_div()
{
let recent_order=Recent_purchase_order_for_popup[(Math.floor(Math.random() * Recent_purchase_order_for_popup.length))]
let message=`<div class="RanPopImg"><img src="${recent_order.product_image}"></div><div class="popup_order_message"><b>`
  if(recent_order.customer_name.length <=15){
     message+=`${recent_order.customer_name}`
 
  }
  else{
  message+=`${recent_order.customer_name.slice(0,15)}.`
  }
message+=`</b> (${recent_order.customer_city.slice(0,15)}), bought<div> <b>${recent_order.product_name.slice(0,20)}...</b></div></div>`;
document.getElementById('popup_order_message_div').innerHTML=message;
setTimeout(function() {document.getElementById('popup_order_message_div').classList.toggle('popup_order_message_div_slide_show')}, 100);
setTimeout(function() {document.getElementById('popup_order_message_div').classList.toggle('popup_order_message_div_slide_show')}, 8000);
}


setInterval(function () {
               load_new_popup_order_message_div();
            }, 8000);

window.addEventListener("load", (event) => {
  console.log("page is fully loaded");
  load_new_popup_order_message_div()
});